module.exports = __webpack_public_path__ + "img/3.2effe94e.jpg";